<template>
  <BaseDataList ref="dataList" :items="purchasedAccProducts" :service="fetchPurchasedAccProducts">
    <template #header>
      <PurchasedAccProductListHeader />
    </template>

    <template #default="{ item }">
      <PurchasedAccProductListItem :acc-product="item" />
    </template>
  </BaseDataList>
</template>

<script>
import { contactPurchasedAccProductsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import PurchasedAccProductListHeader from './PurchasedAccProductListHeader.vue';
import PurchasedAccProductListItem from './PurchasedAccProductListItem.vue';

export default {
  components: {
    PurchasedAccProductListHeader,
    PurchasedAccProductListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      purchasedAccProducts: [],
    };
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    async fetchPurchasedAccProducts(params = {}) {
      try {
        const response = await contactPurchasedAccProductsClient.list(this.contactId, params);

        this.purchasedAccProducts = mapKeysToCamelCase(response?.data || []);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
